import { ApprovalsTasksResponse } from '@Types/api/approvalsList';
import { TypeDict } from '@Types/index';

interface GroupedBulkReturnValue {
  [key: string]: Array<number | string>;
}

const defineRequestType = (requestType: string): string => {
  if (
    requestType !== 'IT Requisition' &&
    requestType !== 'Resignation Request'
  ) {
    return 'HRMRequest';
  }
  return requestType;
};

export const groupedBulkItems = (
  selectedRowKeys: ApprovalsTasksResponse[],
  findRequestTypeBy: (
    criteria: string | number,
    searchBy: 'codeDesc' | 'codeNum' | 'code'
  ) => TypeDict
): GroupedBulkReturnValue => {
  const result = selectedRowKeys?.reduce((acc, currItem) => {
    const taskId = currItem?.taskId;
    const taskType = findRequestTypeBy(
      currItem.requestTypeId,
      'codeNum'
    )?.codeDesc;

    const requestType = defineRequestType(taskType);
    if (acc[requestType]) {
      acc[requestType].push(taskId);
    } else {
      acc = {
        [requestType]: [taskId],
        ...acc,
      };
    }

    return acc;
  }, {} as GroupedBulkReturnValue);

  return result || {};
};
